var collapsible_list_pair_rtlignore_default = {
  "container": "dMO4R",
  "title": "cV7jw",
  "viewerContainer": "Jrmeb",
  "titleContainer": "_765-q",
  "expandIcon": "hQben",
  "dndIcon": "fDCqo",
  "RTL": "wTejs",
  "LTR": "lkbgU",
  "itemContainer": "BaLWE",
  "itemContainerViewer": "qlkEW",
  "mouseDown": "Chh7W",
  "innerEditor": "_9KkRQ",
  "item": "ucW2L",
  "floatingAddPluginMenuWrapper": "w9jyl"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
